import moment from "moment";

export const handleDay = (days: string) => {
    return moment(days).format("yyyy-MM-DD");
}